export default "__VITE_ASSET__ohMHXVc7__"